import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";

import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { FormDateTimePickerProps } from "./types";

import "dayjs/locale/uk";

const FormDateTimePicker: FC<FormDateTimePickerProps> = (props) => {
  const {
    name,
    title,
    rules,
    helperText,
    defaultValue = null,
    ...restDateTimePickerProps
  } = props;

  const {
    control,
    formState: { errors: { [name]: { message = "" } = {} } = {} },
  } = useFormContext();

  const { field } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk">
      <Box mb={2} textAlign="left" sx={{ width: "100%" }}>
        {title && (
          <Typography variant="subtitle2" color="grey800" mb={1}>
            {title}
          </Typography>
        )}
        <DateTimePicker
          {...restDateTimePickerProps}
          format="DD.MM.YYYY HH:mm"
          value={field.value}
          onChange={field.onChange}
          ampm={false}
          localeText={{
            toolbarTitle: "Виберіть дату та час",
          }}
          closeOnSelect={false}
          slotProps={{
            popper: { ...restDateTimePickerProps.slotProps?.popper },
            textField: {
              ...restDateTimePickerProps.slotProps?.textField,
              fullWidth: true,
              error: !!message,
              placeholder: "Виберіть дату та час",
              helperText: typeof message === "string" ? message : "",
            },
          }}
        />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </Box>
    </LocalizationProvider>
  );
};

export default FormDateTimePicker;
